module.exports = "<svg viewBox=\"0 0 19 32\"><path d=\"M2.638 0l15.943 16.057L2.638 32 0 29.477l13.419-13.419L0 2.639z\"></path></svg>"